type FrameProps = {
  src?: string;
  border?: boolean;
  width?: string;
  height?: string;
  title?: string;
};

export const Frame = (props: FrameProps): string => {
  const { src, border, width = '100%', height = '250px', title } = props;

  return `
    <div
      class="overflow-hidden rounded-lg ${border ? 'border' : ''}"
      style="width: ${width}; height: ${height};"
    >
      ${src ? `
      <iframe
        src="${src}"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
        width="${width}"
        height="${height}"
        style="border: 0;"
        title="embed"
        loading="lazy"
        allowfullscreen
        class="block rounded-lg"
      ></iframe>` : ''}
      ${src ? `<span class="block text-center text-sm font-medium">${title}</span>` : ''}
    </div>
  `;
};
